// services/dashboardService.ts

import apiService from './api';
import {
  DashboardOverviewResponse,
  GraphDataResponse,
  StockStatusResponse,
  DashboardOverviewParams,
  GraphDataParams
} from '../types/dashboardTypes';

class DashboardService {
  /**
   * Get dashboard overview with invoices, profit/loss, and stock data
   */
  async getOverview(params?: DashboardOverviewParams): Promise<DashboardOverviewResponse> {
    const queryParams = new URLSearchParams();
    
    if (params?.month) {
      queryParams.append('month', params.month.toString());
    }
    if (params?.year) {
      queryParams.append('year', params.year.toString());
    }

    const queryString = queryParams.toString();
    const url = `/dashboard/overview${queryString ? `?${queryString}` : ''}`;
    
    const response = await apiService.get<DashboardOverviewResponse>(url);
    return response.data;
  }

  /**
   * Get graph data for trends and analytics
   */
  async getGraphs(params?: GraphDataParams): Promise<GraphDataResponse> {
    const queryParams = new URLSearchParams();
    
    if (params?.period) {
      queryParams.append('period', params.period.toString());
    }

    const queryString = queryParams.toString();
    const url = `/dashboard/graphs${queryString ? `?${queryString}` : ''}`;
    
    const response = await apiService.get<GraphDataResponse>(url);
    console.log("responsedssf:::::", response)
    return response.data;
  }

  /**
   * Get real-time stock status
   */
  async getStockStatus(): Promise<StockStatusResponse> {
    const response = await apiService.get<StockStatusResponse>('/dashboard/stock-status');
    return response.data;
  }

  /**
   * Get dashboard overview for current month
   */
  async getCurrentMonthOverview(): Promise<DashboardOverviewResponse> {
    const now = new Date();
    return this.getOverview({
      month: now.getMonth() + 1,
      year: now.getFullYear()
    });
  }

  /**
   * Get graphs for last 6 months (default)
   */
  async getDefaultGraphs(): Promise<GraphDataResponse> {
    return this.getGraphs({ period: 6 });
  }

  /**
   * Get graphs for custom period
   */
  async getGraphsForPeriod(months: number): Promise<GraphDataResponse> {
    return this.getGraphs({ period: months });
  }
}

export const dashboardService = new DashboardService();
export default dashboardService;